import { Component } from "react";
import { ScrollView, View } from "react-native";
import { CricketPlayer, CricketWinScreenProps } from "../../types";
import { CricketResultPlayerCard } from "../components/ResultPlayerCard";
import { primaryColor, secondaryColor, styles } from "../../styles";
import { Button, Text } from "@react-native-material/core";
import { ScrollViewSpacer } from "../../components/ScrollViewSpacer";

export class CricketWinScreen extends Component<CricketWinScreenProps> {
    constructor(props: CricketWinScreenProps) {
        super(props);
    }

    private compareTwoLosers(player1: CricketPlayer, player2: CricketPlayer): number {
        if (player1.score < player2.score) {
            return 1;
        }
        if (player1.score > player2.score) {
            return -1;
        }
    
        return 0;
    }

    render() {
        const rankedLosers = [...this.props.losers].sort(this.compareTwoLosers);
        const loserElements = rankedLosers.map((loser, loserIndex) =>  <CricketResultPlayerCard key={loser.id + "-loser-card"} player={loser} ranking={loserIndex + 2}/>)

        return (
            <ScrollView style={styles.mainPage}>
                <View style={{alignSelf: "flex-end", marginBottom: 22}}>
                    <Button title="Einstellungen ⚙️" color={secondaryColor} onPress={this.props.unsetGameMode}/>
                </View>
                <Text style={styles.headLine1}>Ergebnisse 🏆</Text>
                <CricketResultPlayerCard player={this.props.winner} ranking={1}/>
                {loserElements}
                <Button title="Rematch 🔁" color={primaryColor} onPress={this.props.rematch} style={{margin: 20}}/>
                <ScrollViewSpacer/>
            </ScrollView>
        )
    }
}
